import { createSelector } from '@reduxjs/toolkit'
import { StoreState } from '../index'

const agreementSelector = (state: StoreState) => state.agreement
export const AgreementSelectors = {
  agreements: createSelector([agreementSelector], (state) => state.agreements),
  agreement: createSelector([agreementSelector], (state) => state.agreement),
}
